import React from "react";
import requireAuth from "../auth/requireAuth";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  createOrderService,
  fetchCompanies,
  fetchServiceTypes,
  fetchEquipmentTypes,
} from "../../actions";
import OrderServiceForm from "./OrderServiceForm";

class OrderServiceCreate extends React.Component {
  onSubmit = (formValues) => {
    this.props.createOrderService(formValues);
  };

  render() {
    return (
      <div className={"ui container"}>
        <div className={"ui grid"}>
          <div className={"ui row"}>
            <div
              className={
                "ui eight wide left aligned column bottom aligned content"
              }
            >
              <h2>Nova Ordem de Serviço</h2>
            </div>
            <div
              className={
                "ui four wide right aligned column bottom aligned content"
              }
            >
              <h5>Identificação</h5>
            </div>
            <div
              className={
                "ui four wide right aligned column bottom aligned content"
              }
            >
              <Link
                className={"ui mini icon right labeled button"}
                to={"/order_service/list"}
              >
                <i aria-hidden="true" className="reply icon" /> Voltar
              </Link>
            </div>
          </div>
        </div>
        <div className={"ui divider"} />
        <OrderServiceForm onSubmit={this.onSubmit} />
      </div>
    );
  }
}

export default requireAuth(
  connect(null, {
    createOrderService,
    fetchCompanies,
    fetchServiceTypes,
    fetchEquipmentTypes,
  })(OrderServiceCreate)
);
